/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Play_Pause_TitleInputs */

const en_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play/Pause`)
};

const fr_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture/Pause`)
};

const de_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergabe/Pause`)
};

const it_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riproduci/Pausa`)
};

const ru_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспроизведение/Пауза`)
};

const es_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducir/Pausa`)
};

const zh_cn2_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放/暂停`)
};

const ja_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生/一時停止`)
};

const hi_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चलाएँ/रोकें`)
};

const pt_pt2_player_play_pause_title = /** @type {(inputs: Player_Play_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduzir/Pausar`)
};

/**
* | output |
* | --- |
* | "Play/Pause" |
*
* @param {Player_Play_Pause_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_play_pause_title = /** @type {((inputs?: Player_Play_Pause_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Play_Pause_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_play_pause_title(inputs)
	if (locale === "de") return de_player_play_pause_title(inputs)
	if (locale === "it") return it_player_play_pause_title(inputs)
	if (locale === "ru") return ru_player_play_pause_title(inputs)
	if (locale === "es") return es_player_play_pause_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_play_pause_title(inputs)
	if (locale === "ja") return ja_player_play_pause_title(inputs)
	if (locale === "hi") return hi_player_play_pause_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_play_pause_title(inputs)
	return en_player_play_pause_title(inputs)
});